package br.com.vvrefeicoes.portal.core.ui.layout

import androidx.compose.foundation.HorizontalScrollbar
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.rememberScrollbarAdapter
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
actual fun AppHorizontalScrollbar(
    state: ScrollState,
    modifier: Modifier,
) {
    if (state.maxValue > 0) {
        HorizontalScrollbar(
            adapter = rememberScrollbarAdapter(state),
            modifier = modifier,
            style = appScrollbarStyle(),
        )
    }
}
